import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {
  Aangifte,
  AangifteBerekening,
  AangifteRapport, BokkzAlgDataService,
  BokkzIbDataService,
  IncomeTaxEntity,
  OpbouwWUO,
  SpecificatieWUO
} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject, combineLatest} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-winst-uit-onderneming',
  templateUrl: './overzicht-winst-uit-onderneming.component.html',
  styleUrls: ['./overzicht-winst-uit-onderneming.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class OverzichtWinstUitOndernemingComponent implements OnInit, OnChanges {

    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;

    @Input() aangifteRapport = {} as AangifteRapport;
    @Input() partnerRapport = {} as AangifteRapport;
    @Input() berekening = {} as AangifteBerekening;
    @Input() partnerBerekening = {} as AangifteBerekening;

    specWUOFormGroup = this.fb.group<AangifteRapport>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specWUOFormGroup = this.fb.group<AangifteRapport>(({
            specificatieWUO: this.fb.group<SpecificatieWUO>(({
                opbouw: this.fb.group<OpbouwWUO>(({
                    winstAlleOndernemingen: null as unknown as number,
                    stakingswinstAlleOndernemingen: null as unknown as number,
                    winstAlsMedegerechtigde: null as unknown as number,
                    bijtellingMaximumVerlies: null as unknown as number,
                    winstUitZeescheepvaart: null as unknown as number,
                    vrijgesteldeWinst: null as unknown as number,
                    winstVoorOndernemersaftrek: null as unknown as number,
                    zelfstandigenaftrek: null as unknown as number,
                    startersaftrek: null as unknown as number,
                    zelfstandigenaftrekVoorAOWer: null as unknown as number,
                    senoaftrek: null as unknown as number,
                    meewerkaftrek: null as unknown as number,
                    startersaftrekAO: null as unknown as number,
                    stakingsaftrek: null as unknown as number,
                    restant: null as unknown as number,
                    mkbWinstvrijstelling: null as unknown as number,
                    mkbWinstvrijstellingBijtelling: null as unknown as number,
                    nietgerealiseerdezelstandigenaftrek: null as unknown as number,
                    totaalBenutteStakingsaftrek: null as unknown as number,
                    dotatieFOR: null as unknown as number,
                    vrijvalFOR: null as unknown as number,
                    eindstandFOR: null as unknown as number,
                    dotatieHIR: null as unknown as number,
                    vrijvalHIR: null as unknown as number,
                    eindstandHIR: null as unknown as number,
                    dotatieKER: null as unknown as number,
                    vrijvalKER: null as unknown as number,
                    eindstandKER: null as unknown as number,
                    mutatieReserves: null as unknown as number,
                    totaleBeginvermogen: null as unknown as number,
                    totaleEindvermogen: null as unknown as number,
                    totaleStortingen: null as unknown as number,
                    totaleOnttrekkingen: null as unknown as number,
                    totaleNietAftrekbareKosten: null as unknown as number,
                    fiscaleWinst: null as unknown as number,
                    maximaleDotatieFor: null as unknown as number,
                    fiscaleWinstMinusOAenMkbWv: null as unknown as number,
                } as OpbouwWUO))
            } as SpecificatieWUO))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        combineLatest([this.dataService.incomeTaxEntity, this.partner]).subscribe(
            ([incomeTaxEntity, partner]) => {
                this.partnerBoolean = partner;
                if (incomeTaxEntity.aangifte) {
                    const aangifte = incomeTaxEntity.aangifte as Aangifte;
                    this.aangifte = aangifte;
                    this.updateForm()
                    this.disableFormGroup(this.specWUOFormGroup);
                }
            }
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['aangifteRapport'] || changes['partnerRapport'] || changes['berekening'] || changes['partnerBerekening']) {
            this.updateForm();
        }
    }

    private calculateAndPatchForm(opbouwWUO: any) {
        const winstVoorOndernemersaftrek = opbouwWUO.winstVoorOndernemersaftrek || 0;
        const zelfstandigenaftrek = opbouwWUO.zelfstandigenaftrek || 0;
        const mkbWinstvrijstelling = opbouwWUO.mkbWinstvrijstelling || 0;
        const startersaftrek = opbouwWUO.startersaftrek || 0;
        const zelfstandigenaftrekVoorAOWer = opbouwWUO.zelfstandigenaftrekVoorAOWer || 0;
        const senoaftrek = opbouwWUO.senoaftrek || 0;
        const meewerkaftrek = opbouwWUO.meewerkaftrek || 0;
        const startersaftrekAO = opbouwWUO.startersaftrekAO || 0;
        const stakingsaftrek = opbouwWUO.stakingsaftrek || 0;
        const restant = opbouwWUO.restant || 0;

        const fiscaleWinstMinusOAenMkbWv =
            winstVoorOndernemersaftrek - zelfstandigenaftrek - startersaftrek - zelfstandigenaftrekVoorAOWer - senoaftrek - meewerkaftrek -
            startersaftrekAO - stakingsaftrek - restant - mkbWinstvrijstelling;

        opbouwWUO['fiscaleWinstMinusOAenMkbWv'] = fiscaleWinstMinusOAenMkbWv;
    }

    private calculateMkbWBijtelling(opbouwWUO: any) {
        const mkbWinstvrijstelling = opbouwWUO.mkbWinstvrijstelling || 0;
        opbouwWUO['mkbWinstvrijstellingBijtelling'] = mkbWinstvrijstelling * -1;
    }



    private updateForm() {
        if (this.partnerBoolean) {
            const opbouwWUO = this.partnerRapport?.specificatieWUO?.opbouw;
            if (opbouwWUO) {
                this.calculateAndPatchForm(opbouwWUO);
                this.calculateMkbWBijtelling(opbouwWUO);
            }
            this.specWUOFormGroup.patchValue(this.partnerRapport);
        } else {
            const opbouwWUO = this.aangifteRapport?.specificatieWUO?.opbouw;
            if (opbouwWUO) {
                this.calculateAndPatchForm(opbouwWUO);
                this.calculateMkbWBijtelling(opbouwWUO);
            }
            this.specWUOFormGroup.patchValue(this.aangifteRapport);
        }
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }
}
